module.exports = __webpack_public_path__ + "img/snow-1.7238d815.svg";